(function () {
    'use strict';

    angular.module('iMatApp')
        .factory('promoMessageManager', promoMessageManager);

    promoMessageManager.$inject = ['$q', '$log', '_', 'promoMessageService', 'upload3DModelLocalStorageService', '$uibModal', 'mainWorkspace'];

    function promoMessageManager($q, $log, _, promoMessageService, localStorageService, $uibModal, mainWorkspace) {

        var service = {
            runProductWatching: runProductWatching
        };

        return service;

        // --------------------------------------------------------------------------------------------------------------------

        function runProductWatching($scope) {
            $scope.$watch(function () {
                return mainWorkspace.product.state;
            },
                productChanged);
        }

        function productChanged() {
            if (mainWorkspace.product.state === 'ModelProcessing') {
                promoMessageService.getPromoMessage(mainWorkspace.product.productTemplateId)
                    .then(validate)
                    .then(showPopUp)
                    .then(saveResult);
            }
        }
        
        function validate(promoMessage) {
            if (promoMessage === null) {
                return $q.reject();
            }

            var shownMessage = findShownMessage(promoMessage.id);
            if (shownMessage !== undefined) {
                if (promoMessage.showOnlyOnce === true || shownMessage.dontShow === true) {
                    return $q.reject();
                }
            }

            return $q.resolve(promoMessage);
        }

        function showPopUp(promoMessage) {

            var modalWindow = $uibModal.open({
                templateUrl: '/Scripts/iMatApp/upload3DModel/views/promoMessagePopUp.html',
                controller: 'promoMessageController',
                controllerAs: 'promoMessageViewModel',
                resolve: {
                    promoMessage: promoMessage
                }
            });

            return modalWindow.result;
        }

        function saveResult(result) {
            var shownMessages = getShownPromoMessages();

            var shownMessage = findShownMessage(result.promoMessageId, shownMessages);
            if (angular.isDefined(shownMessage)) {
                shownMessage.dontShow = result.dontShowAgain;
            } else {
                shownMessage = {
                    id: result.promoMessageId,
                    dontShow: result.dontShowAgain
                };
                shownMessages.push(shownMessage);
            }

            localStorageService.promoMessages(shownMessages);
        }

        function findShownMessage(id, shownMessages) {
            shownMessages = shownMessages || getShownPromoMessages();

            return _.find(shownMessages,
                function (item) {
                    return item.id === id;
                });
        }

        function getShownPromoMessages() {
            return localStorageService.promoMessages() || [];
        }
    }
})();